import styled from "styled-components";

export const ChartWrapper = styled.div`
  background: var(--surface);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--accent-light);
  margin-bottom: 24px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 12px;
  }
`;

export const ChartTitle = styled.h3`
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    color: var(--accent);
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`;

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  .recharts-cartesian-grid-horizontal,
  .recharts-cartesian-grid-vertical {
    opacity: 0.5;
  }

  .recharts-tooltip-wrapper {
    z-index: 1000;
  }

  /* Remove focus outline from SVG */
  svg {
    outline: none !important;
  }

  /* Remove focus outline from ResponsiveContainer */
  .recharts-responsive-container {
    outline: none !important;
  }

  /* Remove focus outline from all recharts elements */
  * {
    outline: none !important;
  }
`;

export const CustomTooltip = styled.div`
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--accent);

  .tooltip-label {
    font-size: 12px;
    opacity: 0.8;
    margin-bottom: 4px;
  }

  .tooltip-value {
    font-weight: 600;
    color: var(--accent);
  }
`;

export const LoadingContainer = styled.div`
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  background: linear-gradient(
    135deg,
    rgba(var(--accent-rgb), 0.02) 0%,
    rgba(var(--accent-rgb), 0.05) 100%
  );
  border: 1px solid rgba(var(--accent-rgb), 0.1);

  span {
    font-weight: 500;
  }
`;
